import React from 'react';

const ICSCAvatar = () => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="20" cy="20" r="20" fill="#ECEFF1" />
            <path
                d="M9.5111 18.2519C10.4741 12.4593 15.9555 8.54822 21.7629 9.51118C25.1111 10.0741 27.837 12.1334 29.3481 14.9038L31.4074 13.7778C29.4963 10.2816 26.0889 7.85192 22.1629 7.20007C15.1407 6.0297 8.39998 10.8445 7.22961 17.8667C6.04443 24.8741 10.8148 31.6001 17.8074 32.8001L18.2074 30.489C12.4444 29.4964 8.54813 24.0297 9.5111 18.2519Z"
                fill="#3625A8"
            />
            <path
                d="M16.1778 24.3852C13.9852 21.8963 14.2222 18.1037 16.7111 15.9111C18.163 14.637 20.0593 14.1778 21.8222 14.5185L22.2815 12.1037C19.7037 11.6148 17.037 12.3407 15.0815 14.0741C11.6 17.1407 11.2593 22.5333 14.3407 26.0148C17.3926 29.4815 22.7556 29.837 26.237 26.8L24.6222 24.9481C22.1333 27.0963 18.3704 26.8593 16.1778 24.3852Z"
                fill="#246EFF"
            />
        </svg>
    );
};

export default ICSCAvatar;
